<div class="quick-filter-container">
  <div class="quick-filter-title">{{ 'DISCOUNTS.LIST_VIEW.filters' | translate }}</div>
  <app-date-filter-menu
    [disabled]="disableFilter"
    [endDate]="selectedDateRange?.end_date"
    [fiscalEndDate]="fiscalYear ? fiscalYearService.fiscalYearEndDate(fiscalYear) : null"
    [fiscalStartDate]="fiscalYear ? fiscalYearService.fiscalYearStartDate(fiscalYear) : null"
    [selectedFilter]="selectedDateFilter"
    [startDate]="selectedDateRange?.start_date"
    (filterApplied)="applyDateFilter($event)"
    (filterCleared)="clearDateFilter()"></app-date-filter-menu>
  <app-status-filter-menu
    [disabled]="disableFilter"
    [selectedStatuses]="selectedStatuses"
    (filterApplied)="applyStatusFilter($event)"
    (filterCleared)="clearStatusFilter()"></app-status-filter-menu>
</div>
